var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "omegaup-overlay-popup",
    { on: { dismiss: _vm.onHide } },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "form",
          {
            staticClass: "h-auto w-auto",
            attrs: { "data-demotion-popup": "" }
          },
          [
            _vm.currentView === _vm.AvailableViews.Question
              ? [
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "font-weight-bold pb-4" }, [
                      _vm._v(
                        " " + _vm._s(_vm.T.reportProblemFormQuestion) + " "
                      )
                    ]),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedReason,
                            expression: "selectedReason"
                          }
                        ],
                        staticClass: "control-label w-100",
                        attrs: { name: "selectedReason" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedReason = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "no-problem-statement" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.T.reportProblemFormNotAProblemStatement
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c("option", { attrs: { value: "poorly-described" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.T.reportProblemFormPoorlyDescribed) +
                              " "
                          )
                        ]),
                        _c("option", { attrs: { value: "offensive" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.T.reportProblemFormOffensive) + " "
                          )
                        ]),
                        _c("option", { attrs: { value: "spam" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.T.reportProblemFormSpam) + " "
                          )
                        ]),
                        _c("option", { attrs: { value: "duplicate" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.T.reportProblemFormDuplicate) + " "
                          )
                        ]),
                        _c("option", { attrs: { value: "wrong-test-cases" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.T.reportProblemFormCases) + " "
                          )
                        ]),
                        _c("option", { attrs: { value: "other" } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.T.reportProblemFormOtherReason) +
                              " "
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm.selectedReason == "duplicate"
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "control-label w-100" }, [
                          _vm._v(
                            _vm._s(_vm.T.reportProblemFormLinkToOriginalProblem)
                          )
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.original,
                              expression: "original"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: { name: "original" },
                          domProps: { value: _vm.original },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.original = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "control-label w-100" }, [
                      _vm._v(_vm._s(_vm.T.reportProblemFormAdditionalComments))
                    ]),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rationale,
                          expression: "rationale"
                        }
                      ],
                      staticClass: "input-text w-100",
                      attrs: { name: "rationale", type: "text" },
                      domProps: { value: _vm.rationale },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.rationale = $event.target.value
                        }
                      }
                    })
                  ]),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "col-md-4 btn btn-primary",
                        attrs: {
                          "data-submit-report-button": "",
                          type: "submit",
                          disabled:
                            !_vm.selectedReason ||
                            (!_vm.rationale && _vm.selectedReason == "other") ||
                            (!_vm.original && _vm.selectedReason == "duplicate")
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.onSubmit($event)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.T.wordsSend) + " ")]
                    )
                  ])
                ]
              : _vm._e(),
            _vm.currentView === _vm.AvailableViews.Thanks
              ? [
                  _c("div", { staticClass: "w-100 h-100 h3 text-center" }, [
                    _c("h1", [
                      _vm._v(_vm._s(_vm.T.reportProblemFormThanksForReview))
                    ])
                  ])
                ]
              : _vm._e()
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }